import "../sass/app.scss";

import ThreeSlideCarousel from "./modules/ThreeSlideCarousel";
import HomeCarousel from "./modules/HomeCarousel";
import StickyMenu from "./modules/StickyMenu";
import Animations from "./modules/Animations";
import CollapseMobileMenu from "./modules/CollapseMobileMenu";
import CarouselHeroCaption from "./modules/CarouselHeroCaption";
import ThreeSlidesTextCarousel from "./modules/ThreeSlidesTextCarousel";
import CarouselHeroBanner from "./modules/CarouselHeroBanner";
import ColumnHeightAdjuster from "./modules/ColumnHeightAdjuster";

const threeSlideCarousel = new ThreeSlideCarousel();
const homeCarousel = new HomeCarousel();
const stickyMenu = new StickyMenu();
const animations = new Animations();
const collapseMobileMenu = new CollapseMobileMenu();
const carouselHeroCaption = new CarouselHeroCaption();
const threeSlidesTextCarosel = new ThreeSlidesTextCarousel();
const carouselHeroBanner = new CarouselHeroBanner();
const columnHeightAdjuster = new ColumnHeightAdjuster();